import { Input } from 'antd'
import makeField from 'utils/makeField'

export default makeField(Input)
